import { render, staticRenderFns } from "./MediacontactPartnerCreate.vue?vue&type=template&id=c039e1f4"
import script from "./MediacontactPartnerCreate.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports